"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const ContentSwitcherIcon = ({ switcherOptions, currentOption, onChange }) => {
    const contentSwitcherCN = (index, isActive) => {
        return (0, classnames_template_literals_1.default)(`
      cursor-pointer
      py-[4px]
      px-[4px]
      border border-solid
      ${index === 0 && 'rounded-l-[4px]'}
      ${index === switcherOptions.length - 1 && 'rounded-r-[4px]'}
      ${isActive
            ? 'border-base-600 bg-base-100 active'
            : 'border-n-400 bg-n-000'}
    `);
    };
    return (react_1.default.createElement("div", { className: "flex items-center" }, switcherOptions.map(({ iconName, id, dataCy }, index) => {
        const isActive = currentOption === id;
        return (react_1.default.createElement("div", { className: contentSwitcherCN(index, isActive), key: index, onClick: () => onChange(id), "data-cy": dataCy },
            react_1.default.createElement(SVGIcon_1.default, { iconName: iconName, size: 24, fillColor: isActive ? 'var(--base-600)' : 'var(--n-600)' })));
    })));
};
exports.default = ContentSwitcherIcon;
